/* eslint-disable @intlify/vue-i18n/no-dynamic-keys --
   Este catalogo e a unica fonte das chaves de i18n dos blocos de fluxo; as
   chaves sao literais declarados aqui e resolvidos com t(). */
const definitions = {
  start: {
    icon: 'i-lucide-play',
    titleKey: 'FLOWS.NODES.START.TITLE',
    config: {},
  },
  send_text: {
    icon: 'i-lucide-message-square',
    titleKey: 'FLOWS.NODES.SEND_TEXT.TITLE',
    descriptionKey: 'FLOWS.NODES.SEND_TEXT.DESCRIPTION',
    config: { text: '' },
  },
  wait: {
    icon: 'i-lucide-clock-3',
    titleKey: 'FLOWS.NODES.WAIT.TITLE',
    descriptionKey: 'FLOWS.NODES.WAIT.DESCRIPTION',
    config: { minutes: 60 },
  },
  condition: {
    icon: 'i-lucide-git-branch',
    titleKey: 'FLOWS.NODES.CONDITION.TITLE',
    descriptionKey: 'FLOWS.NODES.CONDITION.DESCRIPTION',
    config: { attribute: 'pipeline_stage', operator: 'equals', value: '' },
  },
  switch: {
    icon: 'i-lucide-git-fork',
    titleKey: 'FLOWS.NODES.SWITCH.TITLE',
    descriptionKey: 'FLOWS.NODES.SWITCH.DESCRIPTION',
    config: {
      cases: [
        {
          branch: 'case_1',
          attribute: 'pipeline_stage',
          operator: 'equals',
          value: '',
        },
      ],
    },
  },
  capture_input: {
    icon: 'i-lucide-message-circle-question',
    titleKey: 'FLOWS.NODES.CAPTURE_INPUT.TITLE',
    descriptionKey: 'FLOWS.NODES.CAPTURE_INPUT.DESCRIPTION',
    config: { variable: 'resposta' },
  },
  assign_agent: {
    icon: 'i-lucide-user-check',
    titleKey: 'FLOWS.NODES.ASSIGN_AGENT.TITLE',
    descriptionKey: 'FLOWS.NODES.ASSIGN_AGENT.DESCRIPTION',
    config: { mode: 'last_responding', agent_id: null },
  },
  set_status: {
    icon: 'i-lucide-circle-dot',
    titleKey: 'FLOWS.NODES.SET_STATUS.TITLE',
    descriptionKey: 'FLOWS.NODES.SET_STATUS.DESCRIPTION',
    config: { status: 'open' },
  },
  set_labels: {
    icon: 'i-lucide-tags',
    titleKey: 'FLOWS.NODES.SET_LABELS.TITLE',
    descriptionKey: 'FLOWS.NODES.SET_LABELS.DESCRIPTION',
    config: { operation: 'add', labels: [] },
  },
  ai_agent: {
    icon: 'i-lucide-sparkles',
    titleKey: 'FLOWS.NODES.AI_AGENT.TITLE',
    descriptionKey: 'FLOWS.NODES.AI_AGENT.DESCRIPTION',
    config: { agent_id: null },
  },
  http_request: {
    icon: 'i-lucide-globe',
    titleKey: 'FLOWS.NODES.HTTP_REQUEST.TITLE',
    descriptionKey: 'FLOWS.NODES.HTTP_REQUEST.DESCRIPTION',
    config: {
      method: 'post',
      url: '',
      headers: '{}',
      body: '',
      response_variable: '',
      timeout_seconds: 10,
    },
  },
  end: {
    icon: 'i-lucide-octagon',
    titleKey: 'FLOWS.NODES.END.TITLE',
    config: { reason: '' },
  },
};

// Ordem e agrupamento da paleta. E o unico lugar que lista os tipos de bloco.
export const PALETTE_GROUPS = [
  { key: 'messages', titleKey: 'FLOWS.PALETTE.MESSAGES', kinds: ['send_text'] },
  {
    key: 'logic',
    titleKey: 'FLOWS.PALETTE.LOGIC',
    kinds: ['wait', 'condition', 'switch'],
  },
  {
    key: 'actions',
    titleKey: 'FLOWS.PALETTE.ACTIONS',
    kinds: ['capture_input', 'assign_agent', 'set_status', 'set_labels'],
  },
  {
    key: 'integrations',
    titleKey: 'FLOWS.PALETTE.INTEGRATIONS',
    kinds: ['ai_agent', 'http_request'],
  },
];

const cloneConfig = config => JSON.parse(JSON.stringify(config || {}));

export const nodeDefinition = (t, kind) => {
  const definition = definitions[kind] || definitions.end;
  return {
    label: t(definition.titleKey),
    config: cloneConfig(definition.config),
  };
};

export const paletteGroups = t =>
  PALETTE_GROUPS.map(group => ({
    key: group.key,
    title: t(group.titleKey),
    items: group.kinds.map(kind => {
      const definition = definitions[kind];
      return {
        kind,
        icon: definition.icon,
        title: t(definition.titleKey),
        description: t(definition.descriptionKey),
      };
    }),
  }));
